import React from 'react';
import PropTypes from 'prop-types';
import joinClassNames from "../../common/JoinClassNames";

const propTypes = {
	onClick: PropTypes.func.isRequired,
	tableSorter: PropTypes.object,
	tableSorterInformation: PropTypes.object,
	thClassName: PropTypes.string,
	title: PropTypes.string.isRequired,
};

const defaultProps = {
	tableSorter: undefined,
	tableSorterInformation: undefined,
	thClassName: undefined,
};

export default class HeaderRow extends React.Component {
	render() {
		return <th
			scope="col"
			className={joinClassNames(this.props.tableSorter ? this.props.tableSorter.headerRowClass(this.props.tableSorterInformation) : '', this.props.thClassName ? this.props.thClassName : '')}
			onClick={this.props.tableSorterInformation ? () => this.props.onClick(this.props.tableSorterInformation) : undefined}
		>
			{this.props.title}
		</th>
	}
}
HeaderRow.defaultProps = defaultProps;
HeaderRow.propTypes = propTypes;
